export default __webpack_public_path__ + "static/media/p4.af32a615.png";